/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_EmptyInputs */

const cs_ares_empty = /** @type {(inputs: Ares_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné firmy.`)
};

const en_ares_empty = /** @type {(inputs: Ares_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No companies found.`)
};

/**
* | output |
* | --- |
* | "No companies found." |
*
* @param {Ares_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_empty = /** @type {((inputs?: Ares_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_empty(inputs)
	return cs_ares_empty(inputs)
});